import rootState from '@/store/state';
import Validatable from '@/validator/Validatable';

export interface IOrganizationFeaturesAPI {
  organization_id: number;
  inventory_management: boolean;
  ssp: boolean;
  ad_server: boolean;
  dsp_campaigns: boolean;
  dsp_deals: boolean;
  reporting: boolean;
  custom_audiences: boolean;
  dashboard: boolean;
  approvals: boolean;
  organization_management: boolean;
  creatives: boolean;
}

export default class OrganizationFeatures extends Validatable {
  organizationID: number;

  internalinventoryManagement: boolean;

  internalssp: boolean;

  internaladServer: boolean;

  internaldspCampaigns: boolean;

  internaldspDeals: boolean;

  internalreporting: boolean;

  internalcustomAudiences: boolean;

  internaldashboard: boolean;

  internalapprovals: boolean;

  internalorganizationManagement: boolean;

  internalcreatives: boolean;

  constructor(
    organizationID = -1,
    inventoryManagement = true,
    ssp = true,
    adServer = true,
    dspCampaigns = true,
    dspDeals = true,
    reporting = true,
    customAudiences = true,
    dashboard = true,
    approvals = true,
    organizationManagement = true,
    creatives = true,
  ) {
    super();
    this.organizationID = organizationID;
    this.internalinventoryManagement = inventoryManagement;
    this.internalssp = ssp;
    this.internaladServer = adServer;
    this.internaldspCampaigns = dspCampaigns;
    this.internaldspDeals = dspDeals;
    this.internalreporting = reporting;
    this.internalcustomAudiences = customAudiences;
    this.internaldashboard = dashboard;
    this.internalapprovals = approvals;
    this.internalorganizationManagement = organizationManagement;
    this.internalcreatives = creatives;
  }

  static fromAPI(apiObject: IOrganizationFeaturesAPI): OrganizationFeatures {
    return new OrganizationFeatures(
      apiObject.organization_id,
      apiObject.inventory_management,
      apiObject.ssp,
      apiObject.ad_server,
      apiObject.dsp_campaigns,
      apiObject.dsp_deals,
      apiObject.reporting,
      apiObject.custom_audiences,
      apiObject.dashboard,
      apiObject.approvals,
      apiObject.organization_management,
      apiObject.creatives,
    );
  }

  toAPI(): IOrganizationFeaturesAPI {
    return {
      organization_id: this.organizationID,
      inventory_management: this.internalinventoryManagement,
      ssp: this.internalssp,
      ad_server: this.internaladServer,
      dsp_campaigns: this.internaldspCampaigns,
      dsp_deals: this.internaldspDeals,
      reporting: this.internalreporting,
      custom_audiences: this.internalcustomAudiences,
      dashboard: this.internaldashboard,
      approvals: this.internalapprovals,
      organization_management: this.internalorganizationManagement,
      creatives: this.internalcreatives,
    };
  }

  static fromObject(obj: any): OrganizationFeatures {
    return super.fromObject(obj, new OrganizationFeatures());
  }

  get inventoryManagement(): boolean {
    return (rootState.debugMode && rootState.user.isGlobalAdmin) || this.internalinventoryManagement;
  }

  get ssp(): boolean {
    return (rootState.debugMode && rootState.user.isGlobalAdmin) || this.internalssp;
  }

  get adServer(): boolean {
    return (rootState.debugMode && rootState.user.isGlobalAdmin) || this.internaladServer;
  }

  get dspCampaigns(): boolean {
    return (rootState.debugMode && rootState.user.isGlobalAdmin) || this.internaldspCampaigns;
  }

  get dspDeals(): boolean {
    return (rootState.debugMode && rootState.user.isGlobalAdmin) || this.internaldspDeals;
  }

  get reporting(): boolean {
    return (rootState.debugMode && rootState.user.isGlobalAdmin) || this.internalreporting;
  }

  get customAudiences(): boolean {
    return (rootState.debugMode && rootState.user.isGlobalAdmin) || this.internalcustomAudiences;
  }

  get dashboard(): boolean {
    return (rootState.debugMode && rootState.user.isGlobalAdmin) || this.internaldashboard;
  }

  get approvals(): boolean {
    return (rootState.debugMode && rootState.user.isGlobalAdmin) || this.internalapprovals;
  }

  get organizationManagement(): boolean {
    return (rootState.debugMode && rootState.user.isGlobalAdmin) || this.internalorganizationManagement;
  }

  get creatives(): boolean {
    return (rootState.debugMode && rootState.user.isGlobalAdmin) || this.internalcreatives;
  }
}
